import { PermissionFormItem } from "./usePermissionForm";

export type PermissionAudience = "partner" | "employee";

const PARTNER_PERMISSION_NAMES = new Set([
  "file.create",
  "file.view",
  "booking.editany",
  "booking.editown",
  "booking.create",
  "booking.editprice",
  "booking.dinnerplaces",
  "booking_option.viewown",
  "booking_option.editown",
  "booking_option.create",
  "partner_feed.viewany",
  "report.prices",
  "report.menu_commission",
]);

const PARTNER_ONLY_PERMISSION_NAMES = new Set<string>([]);

function belongsToAudience(permission: string, audience: PermissionAudience) {
  if (audience === "partner") return PARTNER_PERMISSION_NAMES.has(permission);
  return !PARTNER_ONLY_PERMISSION_NAMES.has(permission);
}

export function filterPermissionsByAudience(
  permissions: PermissionFormItem[],
  audience: PermissionAudience,
) {
  return permissions
    .map(permission => ({
      ...permission,
      actions: permission.actions.filter(action =>
        belongsToAudience(action.permission, audience),
      ),
    }))
    .filter(permission => permission.actions.length > 0);
}
